import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from '../button';

const CommonDeleteModal = ({
  show,
  onHide,
  onConfirm,
  itemDetails,
  title = 'Delete Confirmation',
  instruction = 'Are you sure you want to delete this item?'
}) => {
  return (
    <Modal show={show} onHide={onHide} centered className="send-request-modal">
      <Modal.Header className="modal-header-custom">
        <Modal.Title className="modal-title-custom">{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="modal-body-custom">
        <p className="instruction-text">{instruction}</p>
      </Modal.Body>
      <Modal.Footer className="modal-footer-custom">
        <Button style={{
          backgroundColor: '#ED1A3D',
          color: 'white',
          height: '40px',
          borderRadius: '10px',
          border: 'none',
          cursor: 'pointer',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '10px'
        }} onClick={onConfirm}>
          YES, DELETE
        </Button>
        <Button style={{
          backgroundColor: '#ED1A3D',
          color: 'white',
          height: '40px',
          borderRadius: '10px',
          border: 'none',
          cursor: 'pointer',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '10px'
        }} onClick={onHide}>
          CANCEL
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CommonDeleteModal;